module.exports = __webpack_public_path__ + "55a5b2618ca51f6d9c4181d279b013f5.png";